import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import UiCheckbox from '@/modules/ui/components/ui/UiCheckbox.vue';

type SchemaCheckboxArgs = SchemaControlArgs & {
  label?: string;
};

export class SchemaCheckbox extends SchemaControl<boolean> {
  readonly component = UiCheckbox;
  readonly label?: string;

  constructor(args: SchemaCheckboxArgs) {
    super(args);

    this.label = args.label;
  }
}
